//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './TelehealthBillingClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetTelehealthBillingQueryParameters = {
  invoiceNumber?: string | null | undefined ;
  date?: Date | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export function getUrl(invoiceNumber?: string | null | undefined, date?: Date | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/telehealth-billing?";
if (invoiceNumber !== undefined && invoiceNumber !== null)
    url_ += "InvoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
if (date !== undefined && date !== null)
    url_ += "Date=" + encodeURIComponent(date ? "" + Types.formatDate(date) : "") + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.TelehealthBillingResponseDto, unknown, Types.TelehealthBillingResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.TelehealthBillingResponseDto, unknown, Types.TelehealthBillingResponseDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetTelehealthBillingQueryParameters): QueryKey;
export function getQueryKey(invoiceNumber?: string | null | undefined, date?: Date | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { invoiceNumber, date, offset, limit, sortBy, sortOrder,  } = params[0] as GetTelehealthBillingQueryParameters;

    return trimArrayEnd([
        'TelehealthBillingClient',
        'get',
        invoiceNumber as any,
        date as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'TelehealthBillingClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as Date | null | undefined,       context.queryKey[4] as number | null | undefined,       context.queryKey[5] as number | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as Types.SortOrder | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.TelehealthBillingResponseDto, TError = unknown>(dto: GetTelehealthBillingQueryParameters, options?: Omit<UseQueryOptions<Types.TelehealthBillingResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets data.
 * @param invoiceNumber (optional) 
 * @param date (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetQuery<TSelectData = Types.TelehealthBillingResponseDto, TError = unknown>(invoiceNumber?: string | null | undefined, date?: Date | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.TelehealthBillingResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.TelehealthBillingResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.TelehealthBillingResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let invoiceNumber: any = undefined;
  let date: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ invoiceNumber, date, offset, limit, sortBy, sortOrder,  } = params[0] as GetTelehealthBillingQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [invoiceNumber, date, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.TelehealthBillingResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(invoiceNumber, date, offset, limit, sortBy, sortOrder),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.TelehealthBillingResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets data.
 * @param invoiceNumber (optional) 
 * @param date (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.TelehealthBillingResponseDto | undefined) => Types.TelehealthBillingResponseDto, invoiceNumber?: string | null | undefined, date?: Date | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getQueryKey(invoiceNumber, date, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Gets data.
 * @param invoiceNumber (optional) 
 * @param date (optional) 
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.TelehealthBillingResponseDto | undefined) => Types.TelehealthBillingResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}